import { render, staticRenderFns } from "./addContestantRound.vue?vue&type=template&id=3095baa2&scoped=true&"
import script from "./addContestantRound.vue?vue&type=script&lang=ts&"
export * from "./addContestantRound.vue?vue&type=script&lang=ts&"
import style0 from "./addContestantRound.vue?vue&type=style&index=0&id=3095baa2&lang=scss&scoped=true&"
import style1 from "./addContestantRound.vue?vue&type=style&index=1&id=3095baa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3095baa2",
  null
  
)

export default component.exports